/**
 * This exception is thrown when an attempt is made to create a transaction but there isn't enough balance
 */
export class NotEnoughBalance extends Error {}
/**
 * This exception is thrown when input validation error occurs
 */
export class InputValidationError extends Error {}
